import type { ContextState, Filter, GetterClass } from '../../../models'
import { useFilters } from '../../../composables/use-filters'
import { mapFilter } from '../utils/map-filters'

export class EnabledFiltersGetter implements GetterClass {
  static execute(this: void, state: ContextState): Record<string, Filter> {
    return Object.values(useFilters().availableFilters.value).reduce<Record<string, Filter>>(
      (result, filter) => {
        if (filter.config.enabled) {
          result[filter.config.id] = mapFilter(filter.config.id, filter, state)
        }
        return result
      },
      {},
    )
  }
}
